import { motion } from "framer-motion";
import { TID } from "@/lib/testIds";

// Placeholder testimonials — swap with real parent quotes when ready.
const QUOTES = [
  {
    quote:
      "Coach Owen has been fantastic for our 11-year-old son, Jack, helping improve his movement on the court and develop better shooting techniques.\n\nHis calm, patient temperament creates a positive environment where the kids feel supported and encouraged to learn, and his strong knowledge of the game is evident in every session.\n\nWe highly recommend Owen to any young player looking to improve their basketball while having a great time.",
    name: "Peter",
    role: "Parent · Camperdown",
    kid: "Son, 11",
  },
  {
    quote:
      "Owen is an amazing coach who genuinely understands what each player needs to improve.\n\nHis ability to connect with Xavier, assess his current level and tailor the training accordingly has made a significant difference.\n\nSince working with Owen, Xavier has progressed beyond our expectations in both his skills and understanding of the game.\n\nI would highly recommend Owen to any parent who wants their child to build confidence, improve their basketball knowledge and take their skills to the next level.",
    name: "Victor",
    role: "Parent · Alexandria",
    kid: "Son, 9",
  },
  {
    quote:
      "Owen is a fantastic coach! My son really enjoys his training sessions and has learnt many new skills and techniques.\n\nOwen is supportive and encourages my son to push himself in a positive way. He is a positive role model for young basketball enthusiasts.",
    name: "Kristyl",
    role: "Parent · Alexandria",
    kid: "Son, 8",
  },
];

const rise = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.9,
      ease: [0.22, 1, 0.36, 1],
      delay: i * 0.08,
    },
  }),
};

export const Testimonials = () => (
  <section
    id="testimonials"
    data-testid={TID.testimonials}
    className="relative py-32 md:py-48 px-6 md:px-12 bg-[#080f1e]"
  >
    <div className="max-w-[1600px] mx-auto">
      <div className="grid grid-cols-12 gap-6 mb-20">
        <div className="col-span-12 md:col-span-4">
          <div className="chapter-num mb-6">Testimonials</div>
        </div>
        <div className="col-span-12 md:col-span-8">
          <motion.h2
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-15%" }}
            transition={{ duration: 1, ease: [0.22, 1, 0.36, 1] }}
            className="font-display uppercase text-5xl md:text-7xl leading-[0.9] tracking-tight"
          >
            Straight from
            <br />
            <span className="text-[#2a5fdb]">the parents.</span>
          </motion.h2>
        </div>
      </div>

      <div className="grid grid-cols-12 gap-6">
        {QUOTES.map((q, i) => (
          <motion.figure
            key={q.name}
            custom={i}
            variants={rise}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-10%" }}
            className="col-span-12 md:col-span-4 border border-white/10 bg-[#0a1428] p-8 md:p-10 flex flex-col gap-8"
          >
            <div
              aria-hidden
              className="font-display text-[#2a5fdb] text-7xl leading-none select-none"
            >
              &ldquo;
            </div>
            <blockquote className="text-white/85 text-base md:text-lg leading-relaxed flex-1 flex flex-col gap-4">
              {q.quote.split("\n\n").map((para, idx) => (
                <p key={idx}>{para}</p>
              ))}
            </blockquote>
            <figcaption className="mt-2 pt-6 border-t border-white/10">
              <div className="font-display uppercase text-lg tracking-tight text-white">
                {q.name}
              </div>
              <div className="mt-1 font-mono text-[10px] uppercase tracking-[0.25em] text-white/50">
                {q.role} · {q.kid}
              </div>
            </figcaption>
          </motion.figure>
        ))}
      </div>
    </div>
  </section>
);
